import React , {useState, useEffect, useCallback} from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Popup from '../../components/popup/ProductPopup'
import usePageSEO from '../../hooks/usePageSEO'
import axios from "axios";
import Loader from '../../components/Loader'

const Mounting = () => {
  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;      
  const [open, setOpen] = useState(false);
  const [enquiry, setEnquiry] = useState('');
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  const [product3, setProduct3] = useState(null);
  const [strucCat, setStrucCat] = useState(null);

  const apiUrl = apiBaseUrl+`productpage`;


  const callEnquiry = (txt) =>{
    setEnquiry(txt);
    setOpen(true);
  }


  const fetchInfo = useCallback(() => {
    return axios.get(apiUrl).then((res) => {
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setProduct3(res.data.product3)
      setStrucCat(res.data.structure_category)
    });
  },[]);


  useEffect(() => {
    setTimeout(() => {
      fetchInfo()
        setLoading(false);
    }, 2000);
  }, [fetchInfo]);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  


  return (
    <>
    <Header/>
    { loading && (<Loader /> )}	

	<div className="container" id="mounting-structure"><hr/></div>

    <section className="section-content-block">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">                       
                    <div className="about-us-intro">
                        <p className="blue">{product3?.name}</p>
                        <h2 className="heading">{product3?.heading}</h2>
                        <p>{product3?.description}</p>
                        <button 
                            className="btn btn-button margin-top-60" 
                            onClick={() => callEnquiry('Mounting Structure')}>Enquire now
                        </button>                        
                    </div>                            
                </div> 
                <div className="col-lg-6 col-md-6 col-sm-12 Products text-right">
                    <img src={`${siteUrl}${product3?.image}`} alt={product3?.name}/>               
                </div>

            </div>
            

        </div> 

    </section>

	<div className="container"><hr/></div>
        
    <section className="section-content-block">
        <div className="container">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                    <div className="about-us-intro">
                        <p className="blue">{strucCat?.name}</p>
                        <h2 className="heading">{strucCat?.heading}</h2>
                    </div>                            
                </div> 
                
            </div>
            
            <div className="row">
                {(strucCat?.feature_item.length > 0) && (
                   strucCat.feature_item.map((item,index)=>{
                    return(
                    <div className="col-lg-6 col-md-6 col-sm-12 text-center" key={index}>                       
                        <div className="Products">
                            <img src={`${siteUrl}${item?.image}`} alt={item?.name}/> 
                            <h5 className="heading1"><strong>{item?.name}</strong></h5>
                        </div>                            
                    </div>
                    )
                   })
                )}
            </div>
        </div> 
    </section>

    {open ? <Popup prm={enquiry} closePopup={() => setOpen(false)} /> : null}
    <Footer/>
    </>
  )
}

export default Mounting